import { render, staticRenderFns } from "./UpdateWorkshopContainer.vue?vue&type=template&id=25efb6bc"
import script from "./UpdateWorkshopContainer.vue?vue&type=script&lang=js"
export * from "./UpdateWorkshopContainer.vue?vue&type=script&lang=js"
import style0 from "./UpdateWorkshopContainer.vue?vue&type=style&index=0&id=25efb6bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports